<!-- Segmented control (e.g. Miesięcznie / Kwartalnie / Rocznie — monthly / quarterly / yearly). -->
<script lang="ts" generics="K extends string">
  let { options, value, onselect, id, attr = "k" }: { options: readonly (readonly [K, string])[]; value: K; onselect: (k: K) => void; id?: string; attr?: string } = $props();
</script>

<div class="seg" {id}>
  {#each options as [k, label] (k)}
    <button {...{ [`data-${attr}`]: k }} aria-pressed={k === value} onclick={() => onselect(k)}>{label}</button>
  {/each}
</div>
